import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/profile-bg.jpg")